import { ShieldCheck, RefreshCw, Truck, BadgeIndianRupee } from "lucide-react";

const badges = [
  { icon: ShieldCheck, label: "Secure Payments", sub: "100% protected checkout" },
  { icon: RefreshCw, label: "Easy 7-Day Returns", sub: "Hassle-free exchanges" },
  { icon: BadgeIndianRupee, label: "COD Available", sub: "Pay on delivery" },
  { icon: Truck, label: "Free Shipping", sub: "On orders above ₹2999" },
];

export function TrustBadges() {
  return (
    <div data-testid="trust-badges" className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--line)] border-y border-[var(--line)]">
      {badges.map((b) => (
        <div key={b.label} className="bg-[#FBF7DE] flex items-center gap-4 px-6 py-8">
          <b.icon className="w-7 h-7 text-[var(--olive)] shrink-0" strokeWidth={1.3} />
          <div>
            <div className="font-serif text-lg text-[var(--bronze)] leading-tight">{b.label}</div>
            <div className="text-xs text-[var(--olive)]">{b.sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
